module.exports = __webpack_public_path__ + "static/media/avgjere.9228b053.m4a";